import { ComponentType } from 'react'
import { Col, Row } from 'reactstrap'

interface Props {
  property: any
}

export const Extras: ComponentType<Props> = ({ property }) => {
  const hasComments = !!property.comments

  if (hasComments) {
    return (
      <Row>
        <Col lg={7}>
          <div className="mb-20">
            <h4 className="mb-20 font-family-serif font-size-17 font-weight-bold">Otros</h4>
            {property.comments ? (
              <>
                <h5 className="mb-10 font-size-14 text-uppercase text-primary font-weight-bold">Observaciones</h5>
                <p className="mb-0 line-height-md">{property.comments}</p>
              </>
            ) : null}
          </div>
        </Col>
      </Row>
    )
  }

  return null
}
